// extracted by mini-css-extract-plugin
export default {"shares":"shares--KnwG0","share-btn":"share-btn--i2J0r","shareBtn":"share-btn--i2J0r"};